import GroupDate from "../GroupDate";
import HeaderItem from "../HeaderItem";
import styles from "./TableGroup.module.scss";
import Table from "../Table";

const TableGroup = ({
  group,
  photos,
  isActiveTab,
  setHidden,
  setShowDetailPopup,
  setPopupDetails,
  timezone,
}) => {
  const date = new Date(Object.keys(group)[0]);
  const info = Object.values(group)[0];

  return (
    <div className={styles.wrapper}>
      <GroupDate date={date} />
      {info &&
        Object.values(info)?.map((data, index) => {
          return (
            <div className={styles.item} key={index}>
              <HeaderItem
                photos={photos}
                info={info}
                index={index}
                data={data}
              />
              <Table
                data={data}
                isActiveTab={isActiveTab}
                setHidden={setHidden}
                groupIndex={index}
                photos={photos}
                info={info}
                setShowDetailPopup={setShowDetailPopup}
                setPopupDetails={setPopupDetails}
                timezone={timezone}
              />
            </div>
          );
        })}
    </div>
  );
};

export default TableGroup;
